<script lang="ts" setup>
type BlogArticle = {
  __typename?: 'BlogArticle';
  Components?: Maybe<Array<Maybe<BlogArticleComponentsDynamicZone>>>;
  author?: Maybe<AuthorResponse>;
  category?: Maybe<CategoryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  footer?: Maybe<ComponentBlockFooter>;
  header_image?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<BlogArticleRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String'];
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
}
const props = defineProps<BlogArticle>();
const { d, t } = useI18n();
const category = computed(() => {
  return props.category?.data?.attributes?.name;
});
const subheadline = computed(() => {
  const strings = [];
  if (category.value) strings.push(category.value);
  if (props.publishedAt) strings.push(d(props.publishedAt));
  return strings.join(" ");
});
setSeo(props.seo, props.localizations, "article");
</script>
<i18n lang="json">
{
  "de": {
    "blog": {
      "author": "Autor",
      "published": "Veröffentlicht",
      "topic": "Thema"
    }
  },
  "en": {
    "blog": {
      "author": "Author",
      "published": "Published",
      "topic": "Topic"
    }
  }
}
</i18n>
<template>
  <div>
    <block-header-blog
      class="mt-17"
      :headline="props.title"
      :subheadline="subheadline"
      :background="props.header_image?.data?.attributes"
    />
    <LayoutBlock>
      <div class="blog-article grid gap-34 lg:mt-30 xl:grid-flow-col">
        <aside
          class="blog-article-meta grid auto-rows-max gap-6 md:grid-flow-col xl:grid-flow-row"
        >
          <div v-if="props.author" class="blog-article-author grid gap-1">
            <p class="text-gray">{{ t("blog.author") }}</p>
            <p class="font-pixel font-semibold">
              {{ props.author.firstname }}
              {{ props.author.lastname }}
            </p>
          </div>
          <div v-if="props.publishedAt" class="blog-article-date grid gap-1">
            <p class="text-gray">{{ t("blog.published") }}</p>
            <p class="font-pixel font-semibold">
              {{
                d(props.publishedAt, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
              }}
            </p>
          </div>
          <div v-if="category" class="blog-article-topic grid gap-1">
            <p class="text-gray">{{ t("blog.topic") }}</p>
            <p class="font-pixel font-semibold">
              {{ category }}
            </p>
          </div>
        </aside>
        <article class="blog-article-main max-w-2xl overflow-hidden">
          <BlockRenderer
            v-for="(block, index) in props.Components"
            v-bind="block"
            :key="`${block?.__typename}-${index}`"
            class="mt-15 first:mt-0"
          />
        </article>
      </div>
    </LayoutBlock>
  </div>
</template>
